import { StrictMode } from 'react'
import { createRoot } from 'react-dom/client'
import { MantineProvider, createTheme, colorsTuple } from '@mantine/core'
import '@mantine/core/styles.css'
import App from './App.tsx'
import { buildMeta } from './config/buildMeta.ts'

// Expose the baked-in build metadata so the running bundle is self-describing
// (inspect `window.__APP_BUILD__` in any environment). See ADR 0004 §5 step 7.
window.__APP_BUILD__ = buildMeta

const theme = createTheme({
  fontFamily: 'Inter, sans-serif',
  headings: { fontFamily: '"Plus Jakarta Sans", sans-serif' },
  fontSmoothing: false,
  primaryColor: 'brand',
  // Derived from the --color-primary role so Mantine and Tailwind cannot drift apart.
  // A flat tuple is acceptable only while no Mantine component renders; a real component
  // would need a genuine 10-step ramp built from the primitive.
  colors: { brand: colorsTuple('rgb(var(--color-primary))') },
  defaultRadius: 'md',
})

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <MantineProvider theme={theme}>
      <App />
    </MantineProvider>
  </StrictMode>,
)
